/**
 * Settings Service
 *
 * API calls for site settings management
 */

import { api } from '../lib/api';

export interface SiteSettings {
  company: {
    name: string;
    email: string;
    phone: string;
    address: string;
  };
  quote: {
    validityDays: number;
    terms: string;
  };
  email: {
    from: string;
    replyTo: string;
  };
}

export interface CompanySettings {
  name: string;
  email: string;
  phone: string;
  address: string;
}

export interface QuoteSettings {
  validityDays: number;
  terms: string;
}

export interface EmailSettings {
  from: string;
  replyTo: string;
}

export const settingsService = {
  /**
   * Get all site settings
   */
  getSettings: async (): Promise<SiteSettings> => {
    const response = await api.get<SiteSettings>('/admin/settings');
    return response.data!;
  },

  /**
   * Update company settings
   */
  updateCompanySettings: async (data: CompanySettings): Promise<SiteSettings> => {
    const response = await api.put<SiteSettings>('/admin/settings/company', data);
    return response.data!;
  },

  /**
   * Update quote settings
   */
  updateQuoteSettings: async (data: QuoteSettings): Promise<SiteSettings> => {
    const response = await api.put<SiteSettings>('/admin/settings/quote', data);
    return response.data!;
  },

  /**
   * Update email settings
   */
  updateEmailSettings: async (data: EmailSettings): Promise<SiteSettings> => {
    const response = await api.put<SiteSettings>('/admin/settings/email', data);
    return response.data!;
  },
};
